// controllers/enrollment_engine/checkout_controller.js
import { Controller } from '@hotwired/stimulus';
import { payStripeIntent, stripeBnplPaymentMethods } from '../../modules/checkout/stripe';
import { stripePaymentIntentCheckoutEnabled, showBnplInstallmentTextAndHideNormalInstallments, hideBnplInstallmentTextAndShowNormalPaymentsInstallments } from '../../modules/checkout/checkoutHelpers';
import { payStripeCheckoutSession } from '../../modules/checkout/stripe_checkout_session';
import PaymentDescription from '../../modules/checkout/paymentDescription';

export default class extends Controller {
  static targets = ['payNowButton', 'couponHandle', 'paymentOption', 'couponCodeField', 'checkoutForm', 'paymentMethod', 'paymentIntentForm', 'checkoutSessionForm']

  connect () {
    this.loadForm();
  }

  payNow () {
    if (!stripePaymentIntentCheckoutEnabled()) {
      return;
    }

    if (this.hasCheckoutSessionFormTarget) {
      payStripeCheckoutSession();
      return;
    }

    payStripeIntent();
  }

  updateBreakdown () {
    const paymentMethod = this.paymentMethodTargets.find(element => element.checked)?.value;
    const paymentInstallmentId = document.querySelector('form[id]').dataset.id;
    const numberOfInstallments = this.updateNumberOfInstallments();
    const paymentDescription = new PaymentDescription(numberOfInstallments,
      paymentMethod,
      paymentInstallmentId);
    paymentDescription.reload();
  }

  updateNumberOfInstallments () {
    if (this.paymentOptionTargets.length === 0) { return undefined; }

    let numberOfInstallments;
    const paymentMethod = this.paymentMethodTargets.find(element => element.checked)?.value;

    if (stripeBnplPaymentMethods().includes(paymentMethod)) {
      showBnplInstallmentTextAndHideNormalInstallments();
      this.paymentOptionTargets[0].checked = true;
      numberOfInstallments = 1;
    } else {
      hideBnplInstallmentTextAndShowNormalPaymentsInstallments();
      numberOfInstallments = this.paymentOptionTargets.find(element => element.checked)?.value;
    }
    return numberOfInstallments;
  }

  // The Stripe element is mounted by the enrollment-engine--payment controller,
  // which also owns enabling the form once the element is ready.
  loadForm () {
    if (this.paymentMethodTargets.length > 0 && this.paymentOptionTargets.length > 0) {
      this.updateNumberOfInstallments();
    }
  }

  disableAllElementsHandle () {
    if (this.couponCodeFieldTarget.value) { this.checkoutFormTarget.classList.add('disabled'); }
  }
}
